import BaseModal from 'app/views/modals/base_modal';

import tmpl from 'templates/webhook_delete_modal';

export default BaseModal.extend({
  compiledTemplate: tmpl,

  events: {
    'click .cancel': 'close',
    'click .confirm_delete': 'deleteWebhook',
  },

  deleteWebhook(event) {
    event.preventDefault();
    const self = this;
    this.model.destroy({
      data: { mode: this.model.get('mode') },
      emulateJSON: true,
      wait: true,
      success() {
        self.collection.remove(self.model);
      },
    });
    this.close();
  },
});



// WEBPACK FOOTER //
// ./app/views/modals/webhook_delete_modal.js